import { media, styled } from '@styles';

export const Wrapper = styled.div`
  margin: 146px auto 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 1488px;
  ${media.largeScreen`
    margin: 95px auto 0;
    max-width: 960px;
  `}
  ${media.mediumScreen`
    margin: 64px auto 0;
    max-width: 640px;
  `}
  ${media.smallScreen`
    position: relative;
    margin: 48px auto 0;
    overflow: hidden;
    max-width: 85vw;
  `}

  .slice-download-files__categories-list-bg {
    display: none;
    ${media.smallScreen`
      display: block;
      position: absolute;
      right: 0;
    `}
  }
`;

export const TabList = styled.ul`
  padding-bottom: 36px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(182, 171, 171, 1);
  ${media.largeScreen`
    padding-bottom: 20px;
  `}
  ${media.smallScreen`
    padding: 0 0 16px 0;
    overflow: auto;
    justify-content: flex-start;
  `}
`;

export const TabElement = styled.li`
  display: flex;
  align-items: center;
  opacity: 0.3;
  transition: opacity 0.25s ease-in-out;

  & > button {
    font-family: ${(props) => props.theme.typography.thinFontFamily};
    font-size: ${(props) => props.theme.typography.baseFontSize};
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 100%;
    color: ${(props) => props.theme.colors.baseFont};
    ${media.largeScreen`
      line-height: 100%;
    `}
    ${media.smallScreen`
      white-space: nowrap;
    `}
  }

  &.active,
  &:hover {
    opacity: 1;
  }

  &:not(:last-child) {
    margin-right: 60px;
    ${media.largeScreen`
      margin-right: 40px;
    `}
    ${media.mediumScreen`
      margin-right: 30px;
    `}
    ${media.smallScreen`
      margin-right: 20px;
    `}
  }
`;

export const TabPanel = styled.ul`
  margin-top: 110px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  ${media.largeScreen`
    margin-top: 62px;
  `}
  ${media.mediumScreen`
    justify-content: center;
  `}
  ${media.smallScreen`
    margin-top: 40px;
  `}
`;

export const TabItem = styled.li`
  margin-bottom: 80px;
  width: 584px;
  ${media.largeScreen`
    margin-bottom: 60px;
    width: 440px;
  `}
  ${media.mediumScreen`
    width: 100%;
    max-width: 490px;
  `}
  ${media.smallScreen`
    margin-bottom: 42px;
  `}

  & > a {
    display: flex;
    align-items: center;
    ${media.largeScreen`
      align-items: stretch;
    `}

    &:hover {
      .tab-item__icon-img--active {
        opacity: 1;
      }
    }
  }

  .tab-item {
    &__prev-img {
      margin-right: 30px;
      border-radius: 4px;

      ${media.largeScreen`
        margin-right: 20px;
        height: 72px;
        width: 72px;
      `}
      ${media.smallScreen`
        margin-right: 12px;
        height: 60px;
        width: 60px;
      `}
    }

    &__text-wr {
      display: flex;
      justify-content: space-between;
      flex: 1 0 0;
    }

    &__title * {
      font-family: ${(props) => props.theme.typography.thinFontFamily};
      font-size: ${(props) => props.theme.typography.h4FontSize};
      font-style: normal;
      font-weight: normal;
      font-size: 30px;
      line-height: 110%;
      display: flex;
      align-items: center;
      color: #000000;
    }

    &__description {
      margin-top: 17px;
      display: flex;
      ${media.largeScreen`
        margin-top: 14px;
      `}
      ${media.smallScreen`
        margin-top: 4px;
        display: block;
      `}

      & * {
        font-family: ${(props) => props.theme.typography.extraFontFamily};
        font-size: ${(props) => props.theme.typography.smallFontSize};
        font-style: normal;
        font-weight: normal;
        line-height: 160%;
        color: ${(props) => props.theme.colors.baseFont};
      }
    }

    &__size {
      margin-left: 15px;
      font-family: ${(props) => props.theme.typography.extraFontFamily};
      font-size: ${(props) => props.theme.typography.smallFontSize};
      font-style: normal;
      font-weight: normal;
      line-height: 160%;
      white-space: nowrap;
      color: ${(props) => props.theme.colors.graySemi};
      opacity: 0.5;
      ${media.largeScreen`
        margin-left: 8px;
      `}
      ${media.smallScreen`
        margin-left: 0;
      `}
    }

    &__icon-img {
      ${media.largeScreen`
        height: 50px;
        width: 50px;
      `}
      ${media.smallScreen`
        height: 40px;
        width: 40px;
      `}

      &--active {
        position: absolute;
        opacity: 0;
        transition: opacity 0.25s ease-in-out;
      }
    }

    &__icon-wr {
      position: relative;
      top: 15px;
      ${media.smallScreen`
        top: 12px;
      `}
    }
  }
`;
